import { render, staticRenderFns } from "./AudioTourPage.vue?vue&type=template&id=86d4c524"
import script from "./AudioTourPage.vue?vue&type=script&lang=js"
export * from "./AudioTourPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports